/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import React from 'react';
import downloadImg from 'dndimages/download-icon.png';
import { toSortedSaveObject } from 'utils/MonsterSerialization';

interface DownloadJsonButtonProps {
  getData: () => Record<string, any> | Promise<Record<string, any>>;  // Getter function (sync or async)
  filename: string;
}

const DownloadJsonButton: React.FC<DownloadJsonButtonProps> = ({ getData, filename }) => {

  const handleDownload = async () => {
    const data = await getData();
    const sortedData = toSortedSaveObject(data);
    const jsonStr = JSON.stringify(sortedData, null, 2);
    const blob = new Blob([jsonStr], { type: 'application/json' });
    const url = URL.createObjectURL(blob);

    const a = window.document.createElement('a');
    a.href = url;
    a.download = filename;

    a.click();

    URL.revokeObjectURL(url);
  };

  return (
    <button onClick={handleDownload} id='DownloadMonsterButton' title='Download monster as JSON'>
      <img src={downloadImg} alt="Download monster as JSON" width="16px" /> Download Monster
    </button>
  );
};

export default DownloadJsonButton;
